{
  "no_team_page": {
    "heading": "Your SparkLayer account is not connected to a team",
    "description": "If this looks to be incorrect, you have the following options: ask your account owner to invite you, create a new team below, or <support>contact our support team</support> for assistance.",
    "support_link": "contact our support team",
    "sign_out": "Sign out",
    "create_team": "Create new team"
  }
}
